// extracted by mini-css-extract-plugin
export default {"select":"style_select__w3EIL","header":"style_header__bASbm","label":"style_label__tyYIc","value":"style_value__8gvOp","list":"style_list__nWNyB","open":"style_open__9TqD3"};